import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import React, { useEffect } from "react";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import DashboardCommonTable from "../../components/DashboardCommonTable";
import { Col, notification, Row, Tooltip } from "antd";
import { ClientNameCol, StyledOverFlowDiv, onlyTime } from "./style";
import { formatToINR } from "../../components/FormateToINR/formatToINR";
import { labelObj } from "../../Helper/constant";
import { UplineTag } from "../Users/Accounts/style";

const M2MAlertTable = React.memo(() => {
  const queryClient = useQueryClient();
  const isStale = queryClient.getQueryCache().find(["m2mAlerts"])?.isStale();

  // life cycle
  useEffect(() => {
    if (isStale) {
      queryClient.invalidateQueries({ queryKey: ["m2mAlerts"] });
    }
  }, []);

  // api call
  const getM2mAlert = async ({ pageParam = 1 }) => {
    if (!pageParam) {
      return;
    }
    let response = await APICall(
      "post",
      `${EndPoints.getM2MAlert}&type=m2m&page=${pageParam}&limit=10&isLatest=true`
    );
    return response?.data?.data;
  };

  const alertQuery = useInfiniteQuery({
    queryKey: ["m2mAlerts"],
    queryFn: getM2mAlert,
    getNextPageParam: (lastPage) => lastPage?.nextPage,
    // enabled: canCall,
  });

  if (alertQuery?.error) {
    notification.error({ message: alertQuery?.error?.message });
  }

  const allData = alertQuery?.data?.pages?.flatMap((el) => el?.alerts) || [];

  // column
  const m2mAlertColumns = [
    {
      title: "TIME",
      dataIndex: "time",
      key: "time",
      width: "5rem",
      align: "left",
      render: (text, record) => {
        const time = onlyTime(record?.alertTime);
        return <span>{time}</span>;
      },
    },
    {
      title: "CLIENT",
      dataIndex: "client",
      key: "client",
      align: "left",
      flex: 1,
      ellipsis: true,
      render: (text, record) => {
        return (
          <>
            {/* <Tooltip
            title={`${record?.customerId?.userId} (${record?.customerId?.accountName})`}
            placement="top"
          > */}
            <div>
              <div style={{ fontWeight: "bold" }}>{record?.customerId?.userId}</div>
              <div >{record?.customerId?.accountName}</div>
            </div>
            {/* </Tooltip> */}
          </>
        );
      },
    },
    {
      title: "UPLINE",
      dataIndex: "upline",
      key: "upline",
      align: "left",
      flex: 1,
      ellipsis: true,
      render: (text, record) => {
        let id = record?.customerId?.parent?.userId;
        return (
          <>
            {/* <Tooltip
            title={`${id} (${record?.customerId?.parent?.accountName})`}
            placement="top"
          > */}
            <div>
              <div style={{ fontWeight: "bold" }}>{id}<UplineTag color="magenta" bordered={false}>
                {labelObj[record?.customerId?.parent?.accountType]}
              </UplineTag></div>
              <div >{record?.customerId?.parent?.accountName}</div>
            </div>
            {/* </Tooltip> */}
          </>
        );
      },
    },
    {
      title: "MESSAGE",
      dataIndex: "message",
      key: "message",
      align: "left",
      flex: 1,
      render: (text, record) => {
        return <div>{record?.data?.message}</div>;
      },
    },
    {
      title: "M2M",
      dataIndex: "type",
      key: "type",
      align: "center",
      flex: 1,
      render: (text, record) => {
        return <span>{formatToINR(parseInt(record?.data?.amount))}</span>;
      },
    },
    {
      title: "LEDGER + M2M",
      dataIndex: "lot",
      key: "lot",
      align: "center",
      flex: 1,
      render: (text, record) => {
        return <span>{formatToINR(parseInt(record?.data?.balance))}</span>;
      },
    },
  ];

  return (
    <Col xl={12} lg={24}>
      <DashboardCommonTable
        columns={m2mAlertColumns}
        dataSource={allData?.[0] ? allData : []}
        tableTitle="M2M ALERTS"
        queryKey="m2mAlerts"
        isLoading={alertQuery?.isLoading}
        tradeQuery={alertQuery}
        emptyPage={alertQuery?.data?.pages?.[0]?.alerts?.length === 0}
        viewMore={true}
        allowBtn={false}
      />
    </Col>
  );
});
export default M2MAlertTable;
